import { render } from "./IssueDetails.vue?vue&type=template&id=70fd44aa&scoped=true"
import script from "./IssueDetails.vue?vue&type=script&lang=js"
export * from "./IssueDetails.vue?vue&type=script&lang=js"

import "./IssueDetails.vue?vue&type=style&index=0&id=70fd44aa&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2832102554/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70fd44aa"]])

export default __exports__